export default {"src":"/_next/static/media/helping-lg.mono.473ba73b.svg","height":401,"width":555,"blurWidth":0,"blurHeight":0};